import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { BulkArchiveBatchesResponse } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchIds: string[];
}

export const useBulkArchiveBatches = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchIds }: HookProps): Promise<BulkArchiveBatchesResponse> => {
      const result = await apiClient.batchesArchive.bulkArchiveBatches.mutation({ body: { batchIds } });
      if (result.status !== 200) throw result.body;
      return result.body.data;
    },
    onSuccess: ({ archived, failed }) => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      if (archived.length) {
        toast.success(`Successfully archived ${archived.length} batch${archived.length === 1 ? '' : 'es'}!`);
      }
      if (failed.length) {
        toast.error(`${failed.length} batch${failed.length === 1 ? '' : 'es'} could not be archived.`);
      }
    },
    onError: (error) => {
      showErrorToast(error, 'Error archiving the batches!');
    },
  });
};
